export default __webpack_public_path__ + "static/media/BRONCITA.06ee6b63.jpg";